import { useContext, useState } from "react";
import Logo from "../../../assets/img/logo.svg";
import { AuthContext } from "../../../context/AuthContext";

const LoginPage = () => {
  const { states, actions } = useContext(AuthContext);
  const { loading, error } = states;
  const { handleLogin, setError } = actions;

  const [input, setInput] = useState({ email: "", password: "" });

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
    setError("");
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleLogin(input);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="flex justify-center mb-6">
            <img src={Logo} alt="Marikerja" className="h-10" />
          </div>

          <h1 className="text-2xl font-semibold text-center text-gray-800 mb-2">
            Selamat Datang
          </h1>
          <p className="text-sm text-gray-500 text-center mb-6">
            Masuk untuk melanjutkan ke akunmu
          </p>

          <form onSubmit={onSubmit} className="space-y-4">
            <input
              type="email"
              name="email"
              value={input.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className="w-full rounded-lg border border-gray-300 px-4 py-2.5"
            />
            <input
              type="password"
              name="password"
              value={input.password}
              onChange={handleChange}
              placeholder="Password"
              required
              className="w-full rounded-lg border border-gray-300 px-4 py-2.5"
            />
            {error && (
              <p className="text-red-600 text-sm text-center">{error}</p>
            )}
            <button
              type="submit"
              disabled={loading}
              className={`w-full rounded-lg py-2.5 text-white ${
                loading ? "bg-gray-400" : "bg-indigo-600 hover:bg-indigo-950"
              }`}>
              {loading ? "Memproses..." : "Masuk"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
